import {
    decodeJwt,
    sessionCache,
    signInSuccess,
    SignInSuccess,
    Timer,
    tokenRenew,
} from "modules/auth";
import { DEFAULT_ROLE, userRoles } from "modules/common";
import { getProfile } from "modules/dashboard";
import { AppDispatch } from "store";

export const completeSignIn = (
    dispatch: AppDispatch,
    accessToken: string,
    refreshToken: string,
    returnUrl?: string
) => {
    const cache = sessionCache();
    const body = decodeJwt(accessToken);
    const refreshBody = decodeJwt(refreshToken);

    const getUserRole = (role?: string): { value: number; label: string } => {
        // role is decoded as Role\\{roleType}
        const [, roleType] = role?.split("\\") ?? [];

        return userRoles[roleType] ?? DEFAULT_ROLE;
    };

    const authData: SignInSuccess = {
        userId: body.sub,
        email: body.email,
        accessToken: accessToken,
        refreshToken: refreshToken,
        role: getUserRole(body.role),
        navToken: body.NavToken,
        messageId: body.MessageId,
        oib: body.oib,
        forPersonOib: body.ForPersonOib,
        forLegalIps: body.ForLegalIps,
        toLegalIps: body.ToLegalIps,
        toLegalIzvorReg: body.ToLegalIzvorReg,
        forLegalIzvorReg: body.ForLegalIzvorReg,
        ePoljoprivredaGuid: body.EPoljoprivredaGuid,
        previousLogin: body.previous_login,
        showChangeEntityDialog: Boolean(returnUrl),
    };

    const queryStartIndex = returnUrl?.indexOf("?");
    if (queryStartIndex !== undefined && queryStartIndex !== -1) {
        const query = returnUrl!.substring(queryStartIndex);
        const search = new URLSearchParams(query);
        for (const [key, value] of search.entries()) {
            const property = `${key[0].toLowerCase()}${key.substring(1).replace("_reg", "Reg")}`;
            if (!(property in authData)) continue;

            const authDataKey = property as keyof SignInSuccess;
            const propertyValue = authData[authDataKey];
            if (propertyValue) continue;

            (authData[authDataKey] as string | undefined) = value;
        }
    }

    cache.saveSession({
        ...authData,
        expiration: body.exp,
        refreshExpiration: refreshBody.exp,
    });
    const timer = Timer.getInstance();

    timer.addHandler(async () => {
        dispatch(tokenRenew());
    });

    timer.start(body.exp);

    dispatch(signInSuccess(authData));
    dispatch(getProfile());
};
